import { Reveal, Eyebrow } from "./Reveal";
import { TRUST_CHAPTERS } from "../../data";

export default function Trust() {
  return (
    <section id="story" className="bg-ink py-20 text-cream sm:py-28">
      <div className="mx-auto max-w-6xl px-5">
        <div className="grid gap-12 lg:grid-cols-2">
          <Reveal>
            <Eyebrow dark>Meet the founder — Joshua</Eyebrow>
            <h2 className="mt-4 font-display text-3xl leading-tight sm:text-5xl">
              Why trust a<br />14-year-old detailer?
            </h2>
            <p className="mt-6 max-w-md text-cream/70">
              Hi, I'm Joshua — the founder of Pine &amp; Shine. I may be young, but I
              take this seriously. Every car gets my full attention, honest pricing,
              and work I'm proud to put my name on.
            </p>
            <p className="mt-6 font-display text-2xl text-cream/90">— Joshua</p>
          </Reveal>

          <div className="flex flex-col justify-center gap-8">
            {TRUST_CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div className="border-t border-cream/15 pt-6">
                  <div className="flex items-baseline gap-4">
                    <span className="font-display text-3xl text-cream/40">{c.n}</span>
                    <h3 className="font-display text-xl">{c.title}</h3>
                  </div>
                  <p className="mt-3 text-cream/70">{c.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
